(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('TabOnEventScripts', TabOnEventScripts);

    TabOnEventScripts.$inject = ['$resource'];

    function TabOnEventScripts ($resource) {
        var resourceUrl = 'api/tab-onEvent-scripts/';

        return $resource(resourceUrl, {}, {
            'query': {method : 'GET', isArray : true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'delete':{
                method: 'DELETE',
                url: 'api/tab-onEvent-scripts/delete'
            }
        });
    }
})();
